module.exports = __webpack_public_path__ + "static/prizes-2410bf4a58c2418afb8f14f4846181f6.png";